import { API } from "aws-amplify";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { getProjectDetails } from "actions/projects";

export const GET_APPLIANCE_MIX_DOWNLOAD_TEMPLATE_REQUEST =
  "@@applianceMix/GET_APPLIANCE_MIX_DOWNLOAD_TEMPLATE_REQUEST";
export const GET_APPLIANCE_MIX_DOWNLOAD_TEMPLATE_SUCCESS =
  "@@applianceMix/GET_APPLIANCE_MIX_DOWNLOAD_TEMPLATE_SUCCESS";
export const GET_APPLIANCE_MIX_DOWNLOAD_TEMPLATE_FAILURE =
  "@@applianceMix/GET_APPLIANCE_MIX_DOWNLOAD_TEMPLATE_FAILURE";

export function getApplianceMixDownloadTemplate(
  id = "",
  organisation,
  sample_table = true
) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_APPLIANCE_MIX_DOWNLOAD_TEMPLATE_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_appliance_mix&organisation=${organisation}&sample_table=${sample_table}`;
      }

      const response = await API.get("usimAPI", url);
      dispatch({
        type: GET_APPLIANCE_MIX_DOWNLOAD_TEMPLATE_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_APPLIANCE_MIX_DOWNLOAD_TEMPLATE_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_APPLIANCE_MIX_LIST_REQUEST =
  "@@applianceMix/GET_APPLIANCE_MIX_LIST_REQUEST";
export const GET_APPLIANCE_MIX_LIST_SUCCESS =
  "@@applianceMix/GET_APPLIANCE_MIX_LIST_SUCCESS";
export const GET_APPLIANCE_MIX_LIST_FAILURE =
  "@@applianceMix/GET_APPLIANCE_MIX_LIST_FAILURE";

export function getApplianceMixList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_APPLIANCE_MIX_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_appliance_mix&organisation=${organisation}&sample_table=false`;
      }

      const response = await API.get("usimAPI", url);
      dispatch({
        type: GET_APPLIANCE_MIX_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_APPLIANCE_MIX_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const DELETE_APPLIANCE_MIX_LIST_REQUEST =
  "@@applianceMix/DELETE_APPLIANCE_MIX_LIST_REQUEST";
export const DELETE_APPLIANCE_MIX_LIST_SUCCESS =
  "@@applianceMix/DELETE_APPLIANCE_MIX_LIST_SUCCESS";
export const DELETE_APPLIANCE_MIX_LIST_FAILURE =
  "@@applianceMix/DELETE_APPLIANCE_MIX_LIST_FAILURE";

export function deleteApplianceMixList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: DELETE_APPLIANCE_MIX_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_appliance_mix&organisation=${organisation}`;
      }

      const response = await API.del("usimAPI", url);
      dispatch({
        type: DELETE_APPLIANCE_MIX_LIST_SUCCESS,
        payload: response,
      });
      dispatch(getProjectDetails(id));
    } catch (error) {
      dispatch({
        type: DELETE_APPLIANCE_MIX_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const UPLOAD_APPLIANCE_MIX_DATA_REQUEST =
  "@@applianceMix/UPLOAD_APPLIANCE_MIX_DATA_REQUEST";
export const UPLOAD_APPLIANCE_MIX_DATA_SUCCESS =
  "@@applianceMix/UPLOAD_APPLIANCE_MIX_DATA_SUCCESS";
export const UPLOAD_APPLIANCE_MIX_DATA_FAILURE =
  "@@applianceMix/UPLOAD_APPLIANCE_MIX_DATA_FAILURE";

export function uploadApplianceMixData(
  id = "",
  organisation,
  file,
  columnMappings,
  callback
) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: UPLOAD_APPLIANCE_MIX_DATA_REQUEST,
    });
    try {
      let url = "/presignedurl";
      if (id) {
        url = `${url}?project_id=${id}&table_name=in_appliance_mix`;
      }

      if (!isEmpty(columnMappings)) {
        url = `${url}&column_mappings=${encodeURI(
          JSON.stringify(columnMappings)
        )}`;
      }

      const response = await API.get("usimAPI", url);

      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": file.type },
        body: file,
      };
      await fetch(response.uploadURL, requestOptions).then((response) => {
        if (response.status === 200) {
          toast.success("Data uploaded successfully!");

          setTimeout(() => {
            dispatch(getProjectDetails(id));
            dispatch(getApplianceMixList(id, organisation));
          }, 2000);
          callback({
            success: true,
          });
        } else {
          dispatch({
            type: UPLOAD_APPLIANCE_MIX_DATA_FAILURE,
            payload: {
              message: "Upload data failed.",
            },
          });
        }
      });

      dispatch({
        type: UPLOAD_APPLIANCE_MIX_DATA_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: UPLOAD_APPLIANCE_MIX_DATA_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}
